const tooltip = {
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    border: 'solid 1px #EEEEEE',
    borderRadius: '8px',
    color: '#000',
    filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.2))',
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none',
    textAlign: 'center',
    transform: 'translateY(-50%) translateY(-20px)',
    '& > .MuiBox-root': {
        padding: '1rem',
    },
    zIndex: 10,
};
const defaultCaret = {
    border: 'solid transparent',
    content: '""',
    position: 'absolute',
    height: 0,
    width: 0,
};
const caret = {
    center: {
        '&:after, &:before': {
            ...defaultCaret,
            top: '100%',
        },
        '&:after': {
            borderWidth: '9px 6px 0px 6px',
            borderTopColor: '#fff',
            marginLeft: '-6px',
        },
        '&:before': {
            borderWidth: '10px 7px 0px 7px',
            borderTopColor: '#eee',
            marginLeft: '-7px',
        },
    },
    right: {
        transform: 'translateX(-50%) translateX(-20px)',
        '&:after, &:before': {
            ...defaultCaret,
            top: '50%',
            left: '100%',
        },
        '&:after': {
            borderWidth: '6px 0px 6px 9px',
            borderLeftColor: '#fff',
            marginTop: '-5px',
        },
        '&:before': {
            borderWidth: '7px 0px 7px 10px',
            borderLeftColor: '#eee',
            marginTop: '-6px',
        },
    },
    left: {
        transform: 'translateX(50%) translateX(20px)',
        '&:after, &:before': {
            ...defaultCaret,
            top: '50%',
            right: '100%',
        },
        '&:after': {
            borderWidth: '6px 9px 6px 0px',
            borderRightColor: '#fff',
            marginTop: '-5px',
        },
        '&:before': {
            borderWidth: '7px 10px 7px 0px',
            borderRightColor: '#eee',
            marginTop: '-6px',
            marginLeft: '-1px',
        },
    },
};
export default {
    tooltip,
    caret,
};
